import { F0Box, F0Card } from '@factorialco/f0-react'
import { NumberInput } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface CostBreakdownCardProps {
  emoji: string
  title: string
  description: string
  value: number | null
  currency: string
  onChange: (value: number | null) => void
  error?: string
  action?: React.ReactNode
}

export const CostBreakdownCard = ({
  emoji,
  title,
  description,
  value,
  currency,
  onChange,
  error,
  action,
}: CostBreakdownCardProps) => {
  return (
    <F0Card title={title} description={description} avatar={{ type: 'emoji', emoji }} fullHeight>
      <F0Box
        display="grid"
        columns={action ? '3' : '1'}
        gap="sm"
        alignItems="stretch"
        marginTop="auto"
        width="full"
      >
        <F0Box colSpan={action ? '2' : '1'}>
          <NumberInput
            label={title}
            hideLabel
            locale={i18n.locale}
            units={currency}
            onChange={onChange}
            error={error}
            value={value}
            maxDecimals={2}
            size="md"
          />
        </F0Box>
        {action && (
          <F0Box display="flex" alignItems="stretch">
            {action}
          </F0Box>
        )}
      </F0Box>
    </F0Card>
  )
}
